'use client';

import { useMemo } from 'react';
import Image from 'next/image';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { FacetsViewModel } from '@/types/api';
import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants';
import { Button } from '@/features/button';
import { STOCK_FACET_KEY } from '@/features/filter/constants';
import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import { PLPPages } from '@/app/(plp)/types';
import { getCdnUrl } from '@/utils/url';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
export const NoResults = () => {
  const {
    isMobile
  } = useMobileDetect();
  const pathname = usePathname();
  const {
    deactivateFacets,
    allFacets,
    setOnlyInStock,
    page
  } = usePLPFacetsContext();
  const searchParams = useSearchParams();
  const router = useRouter();
  const searchQuery = searchParams.get(PRODUCT_QUERY_PARAMS.SEARCH);
  const isAnyFilterApplied = !!searchParams.toString();
  const showRemoveFiltersButton = isAnyFilterApplied && (page !== PLPPages.Search || page === PLPPages.Search && [...searchParams.keys()].some(key => key !== PRODUCT_QUERY_PARAMS.SEARCH));
  const noProduct = !isAnyFilterApplied && page !== PLPPages.Search;
  const onClearAllFilters = () => {
    if (!allFacets) {
      const redirectUrl = page === PLPPages.Search ? `/${page}?${PRODUCT_QUERY_PARAMS.SEARCH}=${searchQuery}` : pathname;
      setOnlyInStock?.(false);
      router.push(redirectUrl);
      router.refresh();
      return;
    }
    const keys = [...Object.keys(allFacets), STOCK_FACET_KEY];
    deactivateFacets?.(keys as (keyof FacetsViewModel)[]);
  };
  const NoProductSearch = getCdnUrl('/_toad/images/no-product-search.svg');
  const NoProductFilter = getCdnUrl('/_toad/images/no-product-filter.svg');
  const NoProductAvailable = getCdnUrl('/_toad/images/no-product.svg');
  const productImageSrc = useMemo(() => {
    if (noProduct) return NoProductAvailable;
    if (showRemoveFiltersButton) return NoProductFilter;
    return NoProductSearch;
  }, [NoProductAvailable, NoProductFilter, NoProductSearch, noProduct, showRemoveFiltersButton]);
  const searchMessage = useMemo(() => {
    if (noProduct) {
      return 'فعلا محصولی برای نمایش نداریم!';
    }
    if (showRemoveFiltersButton) {
      return 'محصولی با فیلترهایی که انتخاب کرده‌اید یافته نشد!';
    }
    return <>
                برای جست‌وجوی شما نتیجه‌ای پیدا نشد!
                <br />
                پیشنهاد می‌کنیم عبارت‌های مشابه را جست‌وجو کنید.
            </>;
  }, [noProduct, showRemoveFiltersButton]);
  return <div className='flex grow flex-col items-center justify-center overflow-hidden pb-16 lg:relative lg:min-h-[calc(100dvh_-_246px)] lg:grow-0 lg:pb-0' data-sentry-component="NoResults" data-sentry-source-file="no-results.tsx">
            <div className='flex grow flex-col items-center justify-center lg:grow-0'>
                <Image src={productImageSrc} width={250} height={200} unoptimized className='mb-4' alt='تصویر جست‌وجوی بدون نتیجه' data-sentry-element="Image" data-sentry-source-file="no-results.tsx" />
                <p className='text-center text-body-14 text-text-darkGray lg:text-body-16'>{searchMessage}</p>
            </div>

            {(!allFacets || isMobile) && <div className='flex min-h-[76px] w-screen items-center px-4 lg:mt-3 lg:w-fit'>
                    <Button className='w-full' graphicStyle='outlined' size='medium' onClick={showRemoveFiltersButton ? onClearAllFilters : () => router.push('/')}>
                        {showRemoveFiltersButton ? 'حذف فیلترها' : 'خانه'}
                    </Button>
                </div>}
        </div>;
};